import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';

import { StatusCardSkeletonProps } from './StatusCardSkeleton.types';

const StatusCardSkeleton: React.FC<StatusCardSkeletonProps &
  React.HTMLAttributes<HTMLDivElement>> = ({ className, showButton }) => {
  return (
    <Card className={`flex flex-justify p4 ${className}`}>
      <div className="flex flex-row">
        <Skeleton variant="circle" height={36} width={36} className="mt1" />
        <div className="flex flex-column ml4">
          <BaseSkeleton width={120} height={30} className="mb2" />
          <BaseSkeleton width={120} className="mb2" />
        </div>
      </div>
      {showButton && (
        <Skeleton variant="rect" height={35} width={70} className="mr2 mt2" />
      )}
    </Card>
  );
};

export default StatusCardSkeleton;
export { StatusCardSkeletonProps };
